import React from 'react'

function SubHeader(props) {
    return (
        <div className="subheader-container">
            <div className="subheader-container-div">
                <div className="subheader-title">
                    {props.title}
                </div>
                {props.backText &&
                    <div className="subheader-back-link" onClick={props.navigateBack}>
                        {props.backText}
                    </div>
                }
            </div>
        </div>
    )
}

export default SubHeader